<template>
  <popup ref="popup">
    <div slot="body">
      <el-form
        class="dataForm"
        ref="form"
        :model="parameter"
        :inline="true"
        label-width="80px"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="报销时间" prop="rmtm"
              ><el-input
                :readonly="read"
                v-model="parameter.rmtm"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="报销人" prop="bxemp"
              ><el-input
                :readonly="read"
                v-model="parameter.bxemp"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
           <el-col :span="8">
            <el-form-item label="报销ID" prop="rmid"
              ><el-input
                :readonly="read"
                v-model="parameter.rmid"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="总金额" prop="cost"
              ><el-input
                :readonly="read"
                v-model="parameter.cost"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
  <el-col :span="8">
            <el-form-item label="子项数量" prop="cnt"
              ><el-input
                :readonly="read"
                v-model="parameter.cnt"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发放时间" prop="paytm"
              ><el-input
                :readonly="read"
                v-model="parameter.paytm"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark"
              ><el-input
                :readonly="read"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 5 }"
                v-model="parameter.remark"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="22" :offset="2">
            <el-table :data="subs" style="width: 100%">
              <el-table-column prop="no" label="序号" width="65">
              </el-table-column>
              <el-table-column prop="tm" label="报销时间" width="110">
              </el-table-column>
              <el-table-column prop="nm" label="子项名称" width="200">
              </el-table-column>
              <el-table-column prop="cst" label="金额" width="80">
              </el-table-column>
              <el-table-column prop="rmk" label="备注"> </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="流程审批" prop="sp"
              ><el-input
                :readonly="read"
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 6 }"
                v-model="parameter.sp"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button @click="close()">关 闭</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
export default {
  name: "edit",
  components: {
    popup,
  },
  data() {
    return {
      parameter: {},
      read: true,
      subs: [],
    };
  },
  methods: {
    //打开弹框
    open(parameter, title, disabled, size) {
      this.parameter = parameter;
      this.subs = JSON.parse(this.parameter.subrm);
      this.$refs.popup.open(title, size);
    },
    //关闭弹框
    close() {
      this.$refs.popup.close();
      this.parameter = {};
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
